import { request } from '../index'

export function getBranchSalesPerson(){
    return request({url: "/salespersons/"})
}
export function createSalePerson(data){
    return request({url: "/salespersons/", method: "POST", data})
}
export function deactivateSalesPerson(id){
    return request({url: `/salespersons/${id}/`, method: "DELETE"})
}
export function getSalesPerson(id){
    return request({url: `/salespersons/${id}/`})
}
export function updateSalesPerson(id, data){
    return request({url: `/salespersons/${id}/`, data, method: "PUT"})
}


// WEBPACK FOOTER //
// ./src/api/salespersons/index.js